import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removePre',
})
export class RemovePrePipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/<\/?pre>/g, '');
  }
}
